import {BaseDtoModel} from '../../../Services/Models/base-model.service';

export class TaskFilters extends BaseDtoModel {
  id_local!: number;
  id_departamento!: number;
  id_partida!: number;
  id_periodo!: number;
  check_cerrados_pasado!: boolean;
  check_cerrados_presente!: boolean;
  prog_cerrados_futuro!: boolean;
  prog_cerrados_pasado!: boolean;
  prog_cerrados_presente!: boolean;
  ver_checklists!: boolean;
  ver_programables!: boolean;

  constructor(dataJson?: any) {
    super(dataJson);

    this.init({
      id_local: 0,
      id_departamento: 0,
      id_partida: 0,
      id_periodo: 0,
      check_cerrados_pasado: false,
      check_cerrados_presente: false,
      prog_cerrados_futuro: false,
      prog_cerrados_pasado: false,
      prog_cerrados_presente: false,
      ver_checklists: true,
      ver_programables: true,
    });
  }

}
